import { z } from 'zod';
import { makeStandardLineItemSchema } from '../freightOrder';

export const makeStandardMovementCostsSchema = () => {
  return z.object({
    lineItems: z.array(makeStandardLineItemSchema()),
  });
};

const StandardMovementCostsSchema = makeStandardMovementCostsSchema();
export type StandardMovementCosts = z.infer<typeof StandardMovementCostsSchema>;
